// removed by extract-text-webpack-plugin
module.exports = {"indicator":"styles__indicator___38XNJ"};


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/indicator/styles.css
// module id = HLH5
// module chunks = 2